// eslint-disable-next-line
import React from 'react'
import MUIBreadcrumbs from '@material-ui/core/Breadcrumbs'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { Link as RouterLink } from 'react-router-dom'
import { useBreadcrumbs } from './breadcrumbs.hook'

export type BreadcrumbItem = {
  label: string
  to?: string
}

type BreadcrumbsProps = {
  items: BreadcrumbItem[]
  className?: string
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = (
  props
): React.ReactElement => {
  const { items, className } = props

  const {} = useBreadcrumbs()

  return (
    <MUIBreadcrumbs className={className} aria-label="breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1

        if (isLast || !item.to) {
          return (
            <Typography
              key={`${item.label}-${index}`}
              color="textPrimary"
            >
              {item.label}
            </Typography>
          )
        }

        const to = item.to

        return (
          <Link
            key={to}
            component={RouterLink}
            to={to}
            color="inherit"
          >
            {item.label}
          </Link>
        )
      })}
    </MUIBreadcrumbs>
  )
}
